// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyBPSRTUiPSD9zQVytbrc2zJAT2f1g_RDAE',
    authDomain: 'walaihelpdesk-25638.firebaseapp.com',
    databaseURL: 'https://walaihelpdesk-25638.firebaseio.com',
    projectId: 'walaihelpdesk-25638',
    storageBucket: 'walaihelpdesk-25638.appspot.com',
    messagingSenderId: '378895395486',
    appId: '1:378895395486:web:a777745ce6138b35f5298f',
    measurementId: 'G-E04WHMWHC0'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
